import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import DynamicGradient from "@/components/ui/DynamicGradient";

const FinalCTA = () => {
  const { t } = useTranslation('home');

  return (
    <DynamicGradient className="py-16 bg-geometric-pattern border-t border-border relative overflow-hidden section-curve-top">
      {/* Subtle background decoration */}
      <div className="absolute inset-0 bg-dot-pattern opacity-50" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          className="max-w-3xl mx-auto text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          <span className="section-eyebrow">{t('finalCta.eyebrow')}</span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4">
            {t('finalCta.headline')}
          </h2>
          <motion.p
            className="text-lg text-muted-foreground mb-8 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            {t('finalCta.subheadline')}
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <motion.div
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              transition={{ duration: 0.2 }}
            >
              <Button
                asChild
                size="lg"
                variant="cta"
                className="font-semibold touch-target btn-press"
                onClick={() => {
                  // Track Meta Pixel Contact event
                  if (typeof window !== 'undefined' && (window as any).fbq) {
                    (window as any).fbq('track', 'Contact', {
                      content_name: 'Get Free Inspection Button - CTA'
                    });
                  }
                }}
              >
                <Link to="/book-inspection">{t('finalCta.button')}</Link>
              </Button>
            </motion.div>

            <p className="text-muted-foreground text-sm">
              {t('finalCta.callUs')}{" "}
              <motion.a
                href="tel:+13462200989"
                className="text-navy hover:text-primary transition-colors font-semibold underline"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                (346) 220-0989
              </motion.a>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </DynamicGradient>
  );
};

export default FinalCTA;
